module.exports = __webpack_public_path__ + "img/back.c100fcc0.svg";